/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { ILogPageOwnProps, ILogPageStateProps, ILogPageDispatchProps, LogPage } from "../../components/log/LogPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getLogPage, LogThunkDispatch } from "source/models/store/log/storeLogEffects";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ILogPageOwnProps): ILogPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            logPage: null
        };
    }
    const log = applicationState.log;
    return {
        appState: applicationState.session,
        dataId: log.page.dataId,
        logPage: log.page.logPage
    };
}

export function mapDispatchToProps(dispatch: LogThunkDispatch): ILogPageDispatchProps {
    return {
        onGetLogPage: () => dispatch(getLogPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<ILogPageStateProps, ILogPageDispatchProps, ILogPageOwnProps>(mapStateToProps, mapDispatchToProps)(LogPage);